export default __webpack_public_path__ + "static/media/Campaign.bd5e2b91.svg";